import React from 'react';
import styled from 'styled-components';
import { CompressedImage } from 'web-services/Imgix';
import SecondaryButton from 'web-ui-kit/buttons/SecondaryButton';
import { surfaceM, grayLightM } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import Bone from 'web-ui-kit/loaders/SkeletonBone';
import { Header5LargeStyles, BodySmallSmallStyles, BodySmallBoldLargeStyles } from 'web-ui-kit/typography';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function Addons(_ref) {
  var _ref$addons = _ref.addons,
      addons = _ref$addons === void 0 ? [] : _ref$addons,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? function () {} : _ref$scrollToTop;

  var handleAddonAddToCart = function handleAddonAddToCart(addon) {
    return function (_ref2) {
      var type = _ref2.type,
          payload = _ref2.payload;
      payload.jsEvent.stopPropagation();
      dispatch({
        type: type,
        payload: _objectSpread2(_objectSpread2({}, payload), {}, {
          addon: addon
        })
      });
    };
  };

  var handleAddonCardClick = function handleAddonCardClick(addon) {
    return function (jsEvent) {
      dispatch({
        type: 'pd-addon-card-clicked',
        payload: {
          addon: addon,
          jsEvent: jsEvent
        }
      }); // On internal navigation to addon product, scroll to top.

      scrollToTop();
    };
  };

  var Container = styles.Container,
      Heading = styles.Heading;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "addons"
    },
    /*#__PURE__*/
    React.createElement(Heading, null, copy.heading), loading ? renderLoadingSkeleton() : renderAddonCards({
      addons: addons,
      handleAddonAddToCart: handleAddonAddToCart,
      handleAddonCardClick: handleAddonCardClick
    }))
  );
}
/**
 * Helpers
 */


function renderLoadingSkeleton() {
  var Card = styles.Card,
      CardGrid = styles.CardGrid;
  return (
    /*#__PURE__*/
    React.createElement(CardGrid, null, ['card-1', 'card-2'].map(function (card) {
      return (
        /*#__PURE__*/
        React.createElement(Card, {
          key: card,
          "data-testid": "addon-skeleton-".concat(card)
        },
        /*#__PURE__*/
        React.createElement(Bone, {
          key: "image",
          height: "5.125rem",
          radius: "0"
        }),
        /*#__PURE__*/
        React.createElement("div", null,
        /*#__PURE__*/
        React.createElement(Bone, {
          key: "name",
          height: "1.25rem",
          margin: "0.75rem 0 0.5rem"
        }),
        /*#__PURE__*/
        React.createElement(Bone, {
          key: "price",
          height: "1.125rem",
          width: "50%"
        })),
        /*#__PURE__*/
        React.createElement(Bone, {
          key: "cta",
          height: "2.5rem",
          width: "2.5rem",
          margin: "auto"
        }))
      );
    }))
  );
}

function renderAddonCards(_ref3) {
  var addons = _ref3.addons,
      handleAddonAddToCart = _ref3.handleAddonAddToCart,
      handleAddonCardClick = _ref3.handleAddonCardClick;
  var Card = styles.Card,
      CardGrid = styles.CardGrid,
      CardMeta = styles.CardMeta,
      CardName = styles.CardName,
      CardPrice = styles.CardPrice,
      CardThumbnail = styles.CardThumbnail;
  return (
    /*#__PURE__*/
    React.createElement(CardGrid, null, addons.map(function (addon) {
      var id = addon.id,
          heroImg = addon.heroImg,
          name = addon.name,
          regularPrice = addon.regularPrice; // REMOVING THE ADDONS ADD-TO-CART BUTTON AS PART OF MODSY WIND DOWN
      // const disabled = atcStatus !== 'not-in-cart';
      // const Icon = (() => {
      //   switch (atcStatus) {
      //     case 'adding-to-cart': return <CtaSpinner size={24} variant='primary' />;
      //     case 'added-to-cart': return <CheckIcon size={24} variant='primary' />;
      //     case 'not-in-cart':
      //     default:
      //       return <AddToCartIcon />;
      //   }
      // })();

      return (
        /*#__PURE__*/
        React.createElement(Card, {
          key: id,
          "data-testid": "addon-card-".concat(id),
          onClick: handleAddonCardClick(addon)
        },
        /*#__PURE__*/
        React.createElement(CardThumbnail, {
          alt: name,
          src: heroImg,
          bucketName: "modsy",
          height: 82,
          width: 82
        }),
        /*#__PURE__*/
        React.createElement(CardMeta, null,
        /*#__PURE__*/
        React.createElement(CardName, null, name),
        /*#__PURE__*/
        React.createElement(CardPrice, null, regularPrice.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0
        }))))
      );
    }))
  );
}
/**
 * Copy and Styles
 */


var copy = {
  heading: 'You may also be interested in'
};
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 1.5rem 1rem;\n\n    ", " {\n      padding: 1.5rem 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Heading: styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.5rem;\n  "])), Header5LargeStyles),
  CardGrid: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-row-gap: 0.75rem;\n  "]))),
  Card: styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 5.125rem 1fr 3.5rem;\n    grid-column-gap: 0.75rem;\n\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    cursor: pointer;\n    overflow: hidden;\n  "])), surfaceM, grayLightM),
  CardThumbnail: styled(CompressedImage)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    object-fit: contain;\n    max-width: 100%;\n  "]))),
  CardMeta: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding-top: 0.75rem;\n  "]))),
  CardName: styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n  "])), BodySmallSmallStyles),
  CardPrice: styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BodySmallBoldLargeStyles),
  CardAtcButton: styled(SecondaryButton)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    align-self: center;\n    margin-right: 1rem;\n  "])))
};
export default Addons;